import { render, staticRenderFns } from "./PromoCodePage.vue?vue&type=template&id=3876e3ce&scoped=true&"
import script from "./PromoCodePage.vue?vue&type=script&lang=js&"
export * from "./PromoCodePage.vue?vue&type=script&lang=js&"
import style0 from "./PromoCodePage.vue?vue&type=style&index=0&id=3876e3ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3876e3ce",
  null
  
)

export default component.exports